import Entity from '../entity';
export default class TransferRegion extends Entity<string> {
  name: string;
}
